module.exports = __webpack_public_path__ + "static/media/Att-4.a305149f.png";